// Iter v34cj — TTS-based voice notifications untuk absen kiosk & portal karyawan.
// Pakai Web Speech API (browser bawaan), pilih voice wanita (English) jika tersedia.

let _voicesReady = false;
let _cachedVoice = null;

function _loadVoices() {
  return new Promise((resolve) => {
    if (!("speechSynthesis" in window)) return resolve([]);
    const list = window.speechSynthesis.getVoices();
    if (list && list.length) { _voicesReady = true; return resolve(list); }
    // Some browsers load voices async
    window.speechSynthesis.onvoiceschanged = () => {
      _voicesReady = true;
      resolve(window.speechSynthesis.getVoices());
    };
    // fallback timeout
    setTimeout(() => resolve(window.speechSynthesis.getVoices() || []), 800);
  });
}

async function _pickVoice() {
  if (_cachedVoice) return _cachedVoice;
  const voices = await _loadVoices();
  if (!voices.length) return null;
  // Priority: english female by name → any english female → any english
  const patterns = [
    /(female|zira|susan|samantha|karen|victoria|serena|allison|kate|tessa|moira|fiona|amelie)/i,
    /google.*us.*english/i,
    /english/i,
  ];
  for (const p of patterns) {
    const v = voices.find((vv) => (vv.lang || "").toLowerCase().startsWith("en") && p.test(vv.name || ""));
    if (v) { _cachedVoice = v; return v; }
  }
  // Last resort: any english
  const en = voices.find((v) => (v.lang || "").toLowerCase().startsWith("en"));
  _cachedVoice = en || voices[0];
  return _cachedVoice;
}

export async function speakVoice(text, opts = {}) {
  if (!("speechSynthesis" in window)) return;
  if (opts.enabled === false) return;
  try {
    // Cancel outstanding utterances to avoid overlap
    window.speechSynthesis.cancel();
    const utter = new SpeechSynthesisUtterance(text);
    const voice = await _pickVoice();
    if (voice) utter.voice = voice;
    utter.lang = "en-US";
    utter.rate = opts.rate ?? 1.0;
    utter.pitch = opts.pitch ?? 1.05;
    // Volume 0..1
    const v = typeof opts.volume === "number" ? Math.max(0, Math.min(1, opts.volume)) : 1;
    utter.volume = v;
    window.speechSynthesis.speak(utter);
  } catch { /* ignore */ }
}

// Preset frases (English) — konsisten di semua halaman absen.
export const VOICE_PHRASES = {
  granted: "Access granted",
  denied: "Access denied",
  already: "You have already clocked in",
  thankyou: "Thank you",
};

// Warm up voices (opsional — panggil di useEffect mount)
export function warmupVoices() { _loadVoices(); }
